export default "__VITE_ASSET__CS4eNcp0__"